import { VehicleCategory } from '@navio/nsdk';
import { type FilterOption } from 'noddi-ui-web';
import { VEHICLE_CATEGORY_OPTIONS } from 'noddi-util';
import { VEHICLE_CATEGORY_ICON } from '../../../features/CarDetails/vehicleCategoryIcons';

export const VEHICLE_CATEGORY_FILTER_OPTIONS: FilterOption<VehicleCategory>[] = VEHICLE_CATEGORY_OPTIONS.map(
  (option) => ({ ...option, icon: VEHICLE_CATEGORY_ICON[option.value] })
);

/** Title, description and visible options of this filter, for the builder next to its options. */
export const VEHICLE_CATEGORY_FILTER_TEXT = {
  title: 'Vehicle category',
  description: 'Product vehicle class (passenger, trailer, truck, ...). Drives wheel topology.'
};
